import {getFormatDate} from '@/assets/js/tool';

//弹窗插件
const Msg = new Object();
Msg.install = function(Vue, options) {
    
};

export default Msg;